import { Dialog } from '@delmonicos/shared-design-system-react/src/components/dialog/dialog';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { isAuthenticated } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';

import { LoginView } from './login.view';
import { ResendOtpComponent } from './resend-otp.component';

export const LoginController = (): React.JSX.Element => {
  const { t } = useTranslation();
  const [isForgottenPasswordDialogOpen, setIsForgottenPasswordDialogOpen] =
    useState(false);

  const isAuth = useAppSelector(isAuthenticated);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: Location })?.from;

  useEffect(() => {
    if (isAuth) {
      navigate(
        from
          ? `${from.pathname}${from.search}${from.hash}`
          : APP_PATH.DASHBOARD,
        { replace: true },
      );
    }
  }, [isAuth, navigate, from]);

  return (
    <>
      <LoginView
        handleForgottenPassword={() => setIsForgottenPasswordDialogOpen(true)}
      />
      <Dialog
        onClose={() => setIsForgottenPasswordDialogOpen(false)}
        open={isForgottenPasswordDialogOpen}>
        <Dialog.Header
          onClose={() => setIsForgottenPasswordDialogOpen(false)}
          title={t('$.login.reset-password.title')}
        />
        <Stack direction="column" gap={GapEnum.L}>
          {t('$.login.reset-password.description')}
          <ResendOtpComponent
            onSuccess={() => setIsForgottenPasswordDialogOpen(false)}
            onCancel={() => setIsForgottenPasswordDialogOpen(false)}
          />
        </Stack>
      </Dialog>
    </>
  );
};
